import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GruppeTierModule } from '../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier.module';
import { GruppenModule as GruppenModuleCore } from '../../../projects/kiene-core/src/lib/components/gruppen/gruppen.module';
import { KieneSelectorModule } from '../../../projects/kiene-core/src/lib/components/kiene-selector/kiene-selector.module';
import { MeineKontakteModule } from '../../../projects/kiene-core/src/lib/components/meine-kontakte/meine-kontakte.module';
import { DirectivesModule } from '../../../projects/kiene-core/src/lib/directives/directives.module';
import { OhrmarkeModule } from '../../../projects/kiene-core/src/lib/ohrmarke/ohrmarke.module';
import { AnfrageDetailsModule } from '../components/anfrage-details/anfrage-details.module';
import { KieneClientAutocompleteModule } from '../components/client-autocomplete/client-autocomlete.module';
import { DeleteButtonModule } from '../components/delete-button/delete-button.module';
import { KieneAutocompleteModule } from '../components/kiene-autocomplete/kiene-autocomplete.module';
import { KieneTableModule } from '../components/kiene-table/kiene-table.module';
import { TabinfoModule } from '../components/tabinfo/tabinfo.module';
import { KieneDirectivesModule } from '../directives/kiene-directives.module';
import { GruppenverwaltungModule } from '../documents/gruppenverwaltung/gruppenverwaltung.module';
import { AbhollisteDetailsComponent } from './abhollisten/abholliste-details/abholliste-details.component';
import { AbhollistenComponent } from './abhollisten/abhollisten.component';
import { AbteilDialogComponent } from './abteil-dialog/abteil-dialog.component';
import { AddGruppeTierReklamationDialogComponent } from './add-gruppe-tier-reklamation-dialog/add-gruppe-tier-reklamation-dialog.component';
import { AktuelleGruppenComponent } from './aktuelle-gruppen/aktuelle-gruppen.component';
import { GruppeBemerkungenVerwaltenDialogComponent } from './gruppe-bemerkungen-verwalten-dialog/gruppe-bemerkungen-verwalten-dialog.component';
import { AbteilAendernDialogComponent } from './gruppe-details/abteil-aendern-dialog/abteil-aendern-dialog.component';
import { GewichtePreiseComponent } from './gruppe-details/gewichte-preise/gewichte-preise.component';
import { GruppeDetailsComponent } from './gruppe-details/gruppe-details.component';
import { GruppeEinstallenDialogComponent } from './gruppe-details/gruppe-einstallen-dialog/gruppe-einstallen-dialog.component';
import { HaendlerAendernDialogComponent } from './gruppe-details/haendler-aendern-dialog/haendler-aendern-dialog.component';
import { HerkunftSetzenDialogComponent } from './gruppe-details/herkunft-setzen-dialog/herkunft-setzen-dialog.component';
import { ReklamationenSetzenDialogComponent } from './gruppe-details/reklamationen-setzen-dialog/reklamationen-setzen-dialog.component';
import { KontaktSetzenDialogComponent } from './gruppe-details/kontakt-setzen-dialog/kontakt-setzen-dialog.component';
import { BetriebskontaktAuswahlModule } from '../../../projects/kiene-core/src/lib/components/stammdaten/betriebskontakte/betriebskontakt-auswahl.module';
import { BetriebskontaktCardModule } from '../../../projects/kiene-core/src/lib/components/stammdaten/betriebskontakte/betriebskontakt-card.module';
import { GruppeInformationenDialogComponent } from './gruppe-informationen-dialog/gruppe-informationen-dialog.component';
import { EntsorgerKundenNrNachtragenComponent } from './gruppe-tier-tod-melden/entsorger-kunden-nr-nachtragen/entsorger-kunden-nr-nachtragen.component';
import { GruppeTierTodMeldenComponent } from './gruppe-tier-tod-melden/gruppe-tier-tod-melden.component';
import { GruppeComponent } from './gruppe/gruppe.component';
import { GruppenDashboardModule } from './gruppen-dashboard/gruppen-dashboard.module';
import { GruppenRoutingModule } from './gruppen-routing.module';
import { AbhollisteNumberInputDialogComponent } from './gruppen/globale-tiersuche/abhol-liste-number-input-dialog/abholliste-number-input-dialog.component';
import { AbhollisteFilterDialogComponent } from './gruppen/globale-tiersuche/abholliste-filter-dialog/abholliste-filter-dialog.component';
import { AbhollisteDialogComponent } from './gruppen/globale-tiersuche/add-tier-to-liste-dialog/abholliste-dialog/abholliste-dialog.component';
import { AddTierToListeDialogComponent } from './gruppen/globale-tiersuche/add-tier-to-liste-dialog/add-tier-to-liste-dialog.component';
import { GlobaleTiersucheComponent } from './gruppen/globale-tiersuche/globale-tiersuche.component';
import { GruppenComponent } from './gruppen/gruppen.component';
import { HistorieGruppenComponent } from './historie-gruppen/historie-gruppen.component';
import { HITMeldungenComponent } from './hitmeldungen/hitmeldungen.component';
import { AktuelleGruppenSchweineComponent } from './schweine/aktuelle-gruppen-schweine/aktuelle-gruppen-schweine.component';
import { GruppeSchweinPopupDialogComponent } from './schweine/aktuelle-gruppen-schweine/gruppe-schwein-popup-dialog/gruppe-schwein-popup-dialog.component';
import { AnfrageDetailsComponent } from './schweine/anfrage-details/anfrage-details.component';
import { DetailsVerlaufStatisikenComponent } from './schweine/gruppe-schweine-details/details-verlauf-statisiken/details-verlauf-statisiken.component';
import { GewichtePreiseSchweineComponent } from './schweine/gruppe-schweine-details/gewichte-preise-schweine/gewichte-preise-schweine.component';
import { GruppeSchweineDetailsComponent } from './schweine/gruppe-schweine-details/gruppe-schweine-details.component';
import { TierEditierenDialogComponent } from './tier-editieren-dialog/tier-editieren-dialog.component';
import { TiereAlsCSVUploadDialogComponent } from './tiere-als-csvupload-dialog/tiere-als-csvupload-dialog.component';
import { ZugangMeldenDialogComponent } from './zugang-melden-dialog/zugang-melden-dialog.component';
import { GruppeBelegeComponent } from './gruppe-details/gruppe-belege/gruppe-belege.component';
import { DialogsModule } from '../dialogs/dialogs.module';
import { LandwirtOffeneAnfragenComponent } from './schweine/offene-anfragen/landwirt-offene-anfragen.component';
import { PreiseFestlegenDialogComponent } from './preise-festlegen-dialog/preise-festlegen-dialog.component';
import { GewichteFestlegenDialogComponent } from './gewichte-festlegen-dialog/gewichte-festlegen-dialog.component';

@NgModule({
    declarations: [
        GruppeComponent,
        AktuelleGruppenComponent,
        GruppenComponent,
        GruppeDetailsComponent,
        AddGruppeTierReklamationDialogComponent,
        HistorieGruppenComponent,
        AbteilDialogComponent,
        GruppeTierTodMeldenComponent,
        TierEditierenDialogComponent,
        ZugangMeldenDialogComponent,
        TiereAlsCSVUploadDialogComponent,
        EntsorgerKundenNrNachtragenComponent,
        GruppeInformationenDialogComponent,
        GlobaleTiersucheComponent,
        GruppeEinstallenDialogComponent,
        GruppeBemerkungenVerwaltenDialogComponent,
        HITMeldungenComponent,
        GewichtePreiseComponent,
        HaendlerAendernDialogComponent,
        HerkunftSetzenDialogComponent,
        ReklamationenSetzenDialogComponent,
        KontaktSetzenDialogComponent,
        //schweine
        AnfrageDetailsComponent,
        GruppeSchweineDetailsComponent,
        GewichtePreiseSchweineComponent,
        DetailsVerlaufStatisikenComponent,
        AbhollisteFilterDialogComponent,
        AddTierToListeDialogComponent,
        AbhollisteNumberInputDialogComponent,
        AbhollisteDialogComponent,
        AbhollistenComponent,
        AbhollisteDetailsComponent,
        AbteilAendernDialogComponent,
        GruppeSchweinPopupDialogComponent,
        AktuelleGruppenSchweineComponent,
        GruppeBelegeComponent,
        AbteilAendernDialogComponent,
        GruppeSchweinPopupDialogComponent,
        AktuelleGruppenSchweineComponent,
        LandwirtOffeneAnfragenComponent,
        PreiseFestlegenDialogComponent,
        GewichteFestlegenDialogComponent,
    ],
    exports: [GruppeTierTodMeldenComponent, GruppenComponent],
    imports: [
        CommonModule,
        ClipboardModule,
        GruppenRoutingModule,
        MatTabsModule,
        MatIconModule,
        KieneTableModule,
        MatTabsModule,
        GruppenverwaltungModule,
        MatCardModule,
        MatDialogModule,
        FormsModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatRadioModule,
        MatInputModule,
        MatDatepickerModule,
        MatButtonModule,
        MatCheckboxModule,
        KieneAutocompleteModule,
        KieneSelectorModule,
        MatDividerModule,
        OhrmarkeModule,
        MatMenuModule,
        DeleteButtonModule,
        MatAutocompleteModule,
        MatTooltipModule,
        GruppenModuleCore,
        MatExpansionModule,
        GruppeTierModule,
        GruppenDashboardModule,
        TabinfoModule,
        MatProgressSpinnerModule,
        MatStepperModule,
        DirectivesModule,
        MatListModule,
        AnfrageDetailsModule,
        MatChipsModule,
        KieneClientAutocompleteModule,
        KieneDirectivesModule,
        MeineKontakteModule,
        KieneAutocompleteModule,
        DialogsModule,
        BetriebskontaktAuswahlModule,
        BetriebskontaktCardModule,
    ],
})
export class GruppenModule {}
